import classNames from 'classnames';
import { FC } from 'react';

import Text, { TextProps } from '../Text';

// Component Definition
const Legal: FC<TextProps> = props => (
  <Text
    as="p"
    fontSize="legal"
    {...props}
    className={classNames(props.className, 'text_legal')}
  />
);

export default Legal;
